import { network } from 'services/network';

export const copyLogicCheckerConfigurationBetweenContracts = (params) => {
    return network.post('api/bo/copyLogicCheckerConfigurationBetweenContracts', params).then((response) => {
        return response.data;
    });
};
